.dialog {
	border: none;
	background: transparent;
	padding: 0;
	max-width: min(420px, calc(100vw - var(--space-4)));
	width: 100%;
	max-height: var(--dialog-max-h);
	/* Centres within the safe areas rather than the whole screen, which
	   would put an inset-tall dialog under the status bar. */
	inset: env(safe-area-inset-top) 0 env(safe-area-inset-bottom);
}

/* The dialog only takes focus to absorb showModal()'s autofocus — never ring
   the container itself. */
.dialog:focus,
.dialog:focus-visible {
	outline: none;
}

.dialog::backdrop {
	background: rgba(0, 0, 0, 0.35);
}
